import { render, staticRenderFns } from "./projects-charts.component.vue?vue&type=template&id=3f93cc68&scoped=true&"
import script from "./projects-charts.component.vue?vue&type=script&lang=js&"
export * from "./projects-charts.component.vue?vue&type=script&lang=js&"
import style0 from "./projects-charts.component.vue?vue&type=style&index=0&id=3f93cc68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f93cc68",
  null
  
)

export default component.exports